import { Stack } from '@mui/material';
import { WisdomChatListDrawerIndicator } from '../WisdomChatListDrawerIndicator';
import { WisdomSavedChatsListDrawer } from '../WisdomSavedChatsListDrawer';

interface WisdomChatSidebarProps {
  isOpen: boolean;
  toggleSidebar: () => void;
}

export const WisdomChatSidebar = ({
  isOpen,
  toggleSidebar,
}: WisdomChatSidebarProps) => {
  return (
    <Stack spacing={0} flexDirection="row" overflow="visible">
      <WisdomChatListDrawerIndicator toggleSidebar={toggleSidebar} />
      <WisdomSavedChatsListDrawer isOpen={isOpen} onClose={toggleSidebar} />
    </Stack>
  );
};
